



























import { Component, Vue, } from 'vue-property-decorator';
import {
  State,
  Getter,
} from 'vuex-class'

@Component
export default class Calendar extends Vue {
    private table: Date[][] = [];
    private daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    private hover = null;

    // State things
    @State user;
    @Getter name;
    @Getter isAnonymous;

    get thisMonth() {
        return new Date().getMonth();
    }
    get thisDate() {
        return new Date().getDate();
    }

    isToday(date: Date): boolean {
        const now = new Date();
        return date.getDate() === now.getDate()
            && date.getMonth() === now.getMonth()
            && date.getFullYear() === now.getFullYear();
    }

    private startDate: Date = new Date()
    private endDate: Date = new Date()

    private activeDates: { [key: string]: boolean } = {};

    isActive(date: Date): boolean {
        const datestr = this.dateString(date);
        return this.activeDates[datestr];
    }

    created() {
        const today = new Date();
        const firstOfMonth = new Date(today);
        firstOfMonth.setDate(1);
        const lastOfMonth = new Date(firstOfMonth);
        lastOfMonth.setMonth(lastOfMonth.getMonth()+1);
        lastOfMonth.setDate(0);
        const before = firstOfMonth.getDay();
        const after = 6 - lastOfMonth.getDay();
        const total = lastOfMonth.getDate() + before + after;
        const startDate = new Date(firstOfMonth);
        startDate.setDate(startDate.getDate() - before);
        startDate.setHours(0, 0, 0, 0);
        let date = new Date(startDate);

        for (let i=0; i<total/7; i++) {
            const row: Date[] = [];
            this.table.push(row);
            for (let j=0; j<7; j++) {
                row.push(date);
                date = new Date(date);
                date.setDate(date.getDate()+1);
            }
        }

        this.startDate = startDate;
        this.endDate = new Date(startDate);
        this.endDate.setDate(startDate.getDate() + total);

        this.getActivity();
    }

    dateString(d: Date): string {
        return d.toISOString().substring(0, 10);
    }

    async getActivity() {
        if (!this.user.IsAnonymous) {
            const userid: string = this.user.ID;
            const url = '/calendar/activedates/' + userid;
            try {
                const response = await this.$http.get(
                    url, 
                    { 
                        params: {
                            start: this.dateString(this.startDate),
                            end: this.dateString(this.endDate)
                        }
                    }
                );
                for (const item of response.data ) {
                    Vue.set(this.activeDates, item, true);
                }
            } catch(error) {
                console.log(error.response);
            }
        }
    }

    async toggleActivity(date: Date) {
        if (!this.user.IsAnonymous) {
            const userid: string = this.user.ID;
            const url = '/calendar/activedates/' + userid;
            const dateStr = this.dateString(date);
            const isActive = this.activeDates[dateStr];
            
            const method = (isActive ? "delete" : "post");

            try {
                await this.$http({
                    url,
                    method,
                    data:  { date: dateStr }
                });
                Vue.set(this.activeDates, dateStr, !isActive);
            } catch(error) {
                console.error(error.response);
            }
        }
    }
}

